import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#F29225" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/Nao-Sushi-906273596146726/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Nao Sushi Facebook"
              />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/amigo-cafe-port-coquitlam">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Nao Sushi Zomato"
              />
            </CFLink> */}
            {/* <CFLink href="https://www.instagram.com/pocojimoco/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Nao Sushi Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#F29225" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/Nao-Sushi-906273596146726/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Nao Sushi Facebook"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/amigo-cafe-port-coquitlam">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Nao Sushi Zomato"
                hover
              />
            </CFLink> */}
            {/* <CFLink href="https://www.instagram.com/pocojimoco/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Nao Sushi Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
